module.exports = __webpack_public_path__ + "17cb83b7aa7594c358e19a3451dc5b34.svg";